<template>
    <v-flex
        v-if="value"
        xs12
        text-center
        class="center-loading-circle"
        :style="`min-height: ${minHeight}vh;`">
        <span>
            <v-progress-circular
                indeterminate
                :size="70"
                :width="7"
                class="screen-center main-loading"
                :aria-label="$t('accessibility.loadingGeneric')"
                :color="color"
            />
        </span>
    </v-flex>
</template>

<script>
export default {
    name: 'tz-loading',
    props: {
        color: { type: String, required: false, default: 'primary' },
        minHeight: { type: Number, required: false, default: 90 },
        value: { type: Boolean, required: true },
    },
};
</script>

<style lang="scss" scoped>
    .center-loading-circle {
        min-height: 90vh;
        padding: 0 !important;
        margin: 0 !important;

        .main-loading {
            margin-top: 100px;
        }
    }
</style>
